import { createPost } from "../../api/historyService";

export const useCreatePost = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createPost(data);
            if (successCallback)
            {
                successCallback(newRecord);
            }
            return newRecord;
        } catch (error) {
            console.error("Failed to create post:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};